import {MenuItemModel} from './MenuItemModel';
export class MenuItemsModel {
     items:MenuItemModel[]; 
     label:String;
     currentactive:MenuItemModel;
     active?:boolean;
  
  }
  
 